/* ---------- CP-002's -TB1 takes one protective conductor, from the earthing busbar (CP-002 review 8.2, #3525) ----------
 * The panel wired the drawing's -XD0:PE to -TB1:PE as a conductor of its own, beside the busbar's -WE1 to -TB1:PE: two on one PE
 * terminal (wiring.ts now lands only the busbar's). A save made before holds that conductor, which the wiring step would now call an
 * extra wire. How such a save is read: the save migration in packages/progress uses this (format 29). Self-contained on purpose, as
 * breakers.ts: the migration imports this file alone, not CP-002's pack. */

/** The conductor no longer in the panel. */
export const CP002_TB1_SECOND_PE = { from: "XD0:PE", to: "TB1:PE" } as const;

const same = (w: any) => [w?.from, w?.to].sort().join("|") === [CP002_TB1_SECOND_PE.from, CP002_TB1_SECOND_PE.to].sort().join("|");
/** A build record ({ placements, wires }) without that conductor; anything else keeps its wires. */
function build(b: any): any {
  const wires: any[] = Array.isArray(b?.wires) ? b.wires : [];
  return wires.some(same) ? { ...b, wires: wires.filter(w => !same(w)) } : b;
}

const one = <A extends { ui?: any }>(s: A): A => s?.ui?.build ? { ...s, ui: { ...s.ui, build: build(s.ui.build) } } : s;
/** A saved CP-002 project without -TB1's second PE conductor: its own work and each earlier attempt it keeps ("Start again", #1220). */
export function tb1EarthCp002Save<T extends { ui?: any; attempts?: any[] }>(s: T): T {
  const out = one(s);
  return Array.isArray(s?.attempts) ? { ...out, attempts: s.attempts.map(a => one(a)) } : out;
}
